import {
  LINKS_MANAGEMENT_CLEAR,
  LINKS_MANAGEMENT_LINKS_SET_CONTENT_LINKS_URLS,
  LINKS_MANAGEMENT_LINKS_SET_DETECTION_LINKS_URLS,
} from '../../../../actions/actionTypes';

const defaultState = {
  contentLinkUrls: '',
  detectionLinkUrls: '',
};

export default function (state = defaultState, action) {
  switch (action.type) {
    case LINKS_MANAGEMENT_LINKS_SET_CONTENT_LINKS_URLS:
      return { ...state, contentLinkUrls: action.payload.contentLinkUrls };
    case LINKS_MANAGEMENT_LINKS_SET_DETECTION_LINKS_URLS:
      return { ...state, detectionLinkUrls: action.payload.detectionLinkUrls };
    case LINKS_MANAGEMENT_CLEAR:
      return defaultState;
    default:
      return state;
  }
}
